<!-- Created by Kalpesh date:-03-02-2022 -->

<div class="topDiv" [style.background-color]="backgroundColorScreen">
    <div class="agGridOuterDiv" style="margin-top:3%">
        <div class="E2BMigrationHeader">
            <h4>E2B Migration</h4>
        </div>

    <div style="overflow: hidden;">
        <div class="row" style="margin-top: 15px; margin-left: 1px; margin-right: 1px;">
            <div class="col-12">
                <mat-expansion-panel>
                    <mat-expansion-panel-header style="max-height: 50px;">
                      <mat-panel-title>
                        <label style="font-weight: 500; font-size: large;">E2B Migration Detail</label>
                        <span class="example-spacer"></span>
                      </mat-panel-title>
                      <mat-panel-description>

                      </mat-panel-description>
                    </mat-expansion-panel-header>
                <div style="border-bottom: 0.01px ridge black; margin-right: 20px;"></div>
                <form novalidate [formGroup]='FormValid'>
                    <div style="display: flex;">
                        <label class="col-2" style="font-weight: 500;
                    font-size: medium;padding-top: 8px;">E2B Stage Files Path</label>
                        <mat-form-field class="col-4" appearance="outline" style="width: 40rem;">
                            <mat-label i18n="@@TMshoppingcomplexchooseimage">E2B Stage Files Path</mat-label>
                            <input matInput class="file-path validate" type="text" maxlength="250" placeholder="E2B Stage Files Path" formControlName="e2bstageFiles" id="e2bstageFiles" [(ngModel)]="etobMigrationDetails.e2bstageFiles" readonly>
                        </mat-form-field>
                        <label class="col-2" style="font-weight: 500;
                    font-size: medium;padding-top: 8px;">E2B FTP Path</label>
                        <mat-form-field class="col-4" appearance="outline" style="width: 40rem;">
                            <mat-label i18n="@@TMshoppingcomplexchooseimage">E2B FTP Path</mat-label>
                            <input matInput class="file-path validate" type="text" maxlength="250" placeholder="E2B FTP Path" formControlName="e2bftpPath" id="e2bftpPath" [(ngModel)]="etobMigrationDetails.e2bftpPath" readonly>
                        </mat-form-field>
                    </div>
                    <div style="display: flex;">
                        <label class="col-2" style="font-weight: 500;
                    font-size: medium;padding-top: 8px;">Literature Stage Files Path</label>
                        <mat-form-field class="col-4" appearance="outline" style="width: 40rem;">
                            <mat-label i18n="@@TMshoppingcomplexchooseimage">Literature Stage Files Path</mat-label>
                            <input matInput class="file-path validate" type="text" maxlength="250" placeholder="Literature Stage Files Path" formControlName="literaturestageFiles" id="literaturestageFiles" [(ngModel)]="etobMigrationDetails.literaturestageFiles" readonly>
                        </mat-form-field>
                        <label class="col-2" style="font-weight: 500;
                    font-size: medium;padding-top: 8px;">Literature FTP Path</label>
                        <mat-form-field class="col-4" appearance="outline" style="width: 40rem;">
                            <mat-label i18n="@@TMshoppingcomplexchooseimage">Literature FTP Path</mat-label>
                            <input matInput class="file-path validate" type="text" maxlength="250" placeholder="Literature FTP Path" formControlName="literatureftpPath" id="literatureftpPath" [(ngModel)]="etobMigrationDetails.literatureftpPath" readonly>
                        </mat-form-field>
                    </div>
                    <div style="display: flex;">
                        <label class="col-2" style="font-weight: 500;
                    font-size: medium;padding-top: 8px;">Attachment Stage Files Path</label>
                        <mat-form-field class="col-4" appearance="outline" style="width: 40rem;">
                            <mat-label i18n="@@TMshoppingcomplexchooseimage">Attachment Stage Files Path</mat-label>
                            <input matInput class="file-path validate" type="text" maxlength="250" placeholder="Attachment Stage Files Path" formControlName="attachmentstageFiles" id="attachmentstageFiles" [(ngModel)]="etobMigrationDetails.attachmentstageFiles" readonly>
                        </mat-form-field>
                        <label class="col-2" style="font-weight: 500;
                    font-size: medium;padding-top: 8px;">Attachment FTP Path</label>
                        <mat-form-field class="col-4" appearance="outline" style="width: 40rem;">
                            <mat-label i18n="@@TMshoppingcomplexchooseimage">Attachment FTP Path</mat-label>
                            <input matInput class="file-path validate" type="text" maxlength="250" placeholder="Attachment FTP Path" formControlName="attachmentftpPath" id="attachmentftpPath" [(ngModel)]="etobMigrationDetails.attachmentftpPath" readonly>
                        </mat-form-field>
                    </div>
                    <div style="display: flex;">
                        <label class="col-2" style="font-weight: 500;
                    font-size: medium;padding-top: 8px;">Attachment Mapping File</label>
                        <mat-form-field class="col-2" appearance="outline" style="width: 40rem;">
                            <mat-label i18n="@@TMshoppingcomplexchooseimage">Attachment Mapping File</mat-label>
                            <input matInput class="file-path validate" type="text" maxlength="250" placeholder="Attachment Mapping File" formControlName="attachmentmappingFile" id="attachmentmappingFile" [(ngModel)]="statevaluechange.fileName" readonly required>
                        </mat-form-field>
                        <div style="display: flex;" class="file-field col-2">
                            <a class="btn-floating btn-sm m-0">
                                <em class="fas fa-paperclip mt-0" style="text-rendering: auto;color:black"></em>
                             
                                <input type="file" id="imageupload" name="imageupload" (change)="attachmentMappingFile($event,'csv')" formControlName="imageupload">
                            </a>
                            <div>
                            <button style="margin-left: 10px;" class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [style.background-color]="backgroundColorButton" title="Upload" (click)="uploadFile()">Upload
                                <em style="padding: 0px 0px 0px 10px;" class="fas fa-upload example-icon" title="Upload"></em>
                            </button></div>
                        </div>
                    <mat-checkbox formControlName="isCheckboxSelected" ngDefaultControl [(ngModel)]="isCheckboxSelected" class="mat-checkbox-layout col-2" style="padding-top: 8px;">
                      <span>
                       Files Present in FTP?
                      </span>  </mat-checkbox>
                      <button i18n="@@TMRunButton" type="button" (click)="startMigration()"
                      style="border: 1px solid; color: black; justify-content: flex-start; margin-left: 15px;"
                      class="startMgrButton popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [style.border-color]="backgroundColorButton">Start Migration</button>
                </div>
            </form>
                </mat-expansion-panel>
            </div>
        </div>

    <div>
        <div [style.background-color]="backgroundColorScreen">

            <div class="agGridOuterDiv">
                <div>

                    <mat-toolbar class="agGridtoperDiv card" style="background: rgb(228 227 230 / 41%);border-top: 1px solid #a9a9a9a8; border-right: 1px solid #a9a9a9a8; border-left: 1px solid #a9a9a9a8;">
                        <label i18n="@@spmsUserReg" class="textColour">Run History</label>
                        <span class="example-spacer"></span>

                        <div style="display:flex; justify-content: center;">
                            <button i18n="@@TMRunButton" type="button" (click)="abortMigration()"             style="border: 1px solid; color: black; justify-content: flex-start;" class="abortMgrButton popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [style.border-color]="backgroundColorButton">Abort Migration</button>
                        </div>

                    </mat-toolbar>
                </div>
                    <div>
                        <ag-grid-angular style="height: 200px;" id="Grid" class="ag-theme-balham table-width-fields tablestyles square scroolbar-dusty-grass square thin" [columnDefs]="columnDefs"  [animateRows]="true"  [defaultColDef]="defaultColDef" [suppressPaginationPanel]="true"
                    [rowSelection]="rowSelectionForTablesFields" [rowHeight]="35" [headerHeight]="35" [enableBrowserTooltips]="true" [floatingFiltersHeight]="45" [enableRangeSelection]="true" [debug]="true" [components] ="components"
                    (gridReady)="onGridReadymigration($event)" (cellClicked)="cellClickedObjects($event)"  [hidden]="!true">
                    </ag-grid-angular>

                    </div>

            </div>
        </div>

    </div>

    <div>
        <div  [style.background-color]="backgroundColorScreen">
            <div class="agGridOuterDiv">
                <div>
                    <mat-toolbar class="agGridtoperDiv card" style="background: rgb(228 227 230 / 41%);border-top: 1px solid #a9a9a9a8; border-right: 1px solid #a9a9a9a8; border-left: 1px solid #a9a9a9a8;">
                        <label i18n="@@spmsUserReg" class="textColour">Migration Tasks</label>
                        <span class="example-spacer"></span>
                        <button class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [style.background-color]="backgroundColorButton" title="Upload" (click)="loadFile()" id="114">Add Task
                        </button>
                        <button class="refreshButton popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [style.background-color]="backgroundColorButton" title="Refresh" (click) = "refresh()">
                            Refresh<em style="padding: 0px 0px 0px 10px;" class="fas fa-refresh" title="Refresh"></em>
                        </button>
                        <button class="popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize" [style.background-color]="backgroundColorButton" title="Download" (click) = "onBtExport()">
                            Download<em style="padding: 0px 0px 0px 10px;" class="fas fa-download example-icon" title="Download"></em>
                        </button>
                        <div class="insertPageNoDiv">
                            <mat-form-field appearance="outline">
                                <mat-label i18n="@@Targetpageno">Page No</mat-label>
                                <input matInput type="text" (input)="onSearchChange($event.target.value)">
                            </mat-form-field>
                        </div>
                        <div class="selectRecordsDiv" style="width:9.5%">
                            <mat-form-field appearance="outline" style="width:100%">
                                <mat-label i18n="@@Targetrecords" style="color:black">Records</mat-label>
                                <mat-select [(ngModel)]="pageSize" ngDefaultControl (ngModelChange)="onPageSizeChanged(value)">
                                    <mat-option value="10" selected>10</mat-option>
                                    <mat-option value="200">200</mat-option>
                                    <mat-option value="300">300</mat-option>
                                    <mat-option value="400">400</mat-option>
                                </mat-select>

                            </mat-form-field>
                        </div>
                        <div class="card pagination paginationFirstButton paginationFirstlastButton">
                            <em class="fas fa-angle-double-left waves-effect waves-light" (click)="onBtFirst()"></em>
                        </div>
                        <div class="card pagination paginationButtons btn-rounded">
                            <ul>
                                <li class="paginationliicon">
                                    <em class="fas fa-angle-left waves-effect waves-light" (click)="onBtPrevious()"></em>
                                </li>
                                <li>{{currentPage}}/{{totalPages}}</li>
                                <li class="paginationliicon" style="padding:0;">
                                    <em class="fas fa-angle-right waves-effect waves-light" (click)="onBtNext()"></em>
                                </li>
                            </ul>
                        </div>
                        <div class="card pagination paginationLastButton paginationFirstlastButton">
                            <em class="fas fa-angle-double-right waves-effect waves-light" (click)="onBtLast()"></em>
                        </div>

                    </mat-toolbar>
                </div>
                <div>

                    <ag-grid-angular class="ag-theme-balham table-width-tabs tablestyles square scroolbar-dusty-grass square thin" [columnDefs]="columnDefsE2B" [animateRows]="true"  [pagination]="true" [rowSelection]="rowSelection" [defaultColDef]="defaultColDef" [suppressPaginationPanel]="true" [rowHeight]="35" [headerHeight]="35" [enableBrowserTooltips]="true" [floatingFiltersHeight]="45"[paginationPageSize]="paginationPageSize" [paginationNumberFormatter]="paginationNumberFormatter" [enableRangeSelection]="true" [debug]="true"  (paginationChanged)="onPaginationChanged()" [components] ="components" (gridReady)="onGridE2Bmigration($event)" [hidden]="!true"></ag-grid-angular>

                </div>
            </div>
        </div>
    </div>

    </div>
</div>
